module.exports = __webpack_public_path__ + "img/team_4.797b1d4a.png";